import React, { useState } from "react";

const AddTransaction = ({ onAdd }) => {
  const [form, setForm] = useState({
    title: "",
    amount: "",
    type: "expense",
    category: "Food",
    date: new Date().toISOString().slice(0,10),
    note: ""
  });

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    if (!form.title || !form.amount) return;
    
    onAdd({
      title: form.title,
      type: form.type,
      category: form.category,
      amount: Number(form.amount),
      description: form.note,
      date: form.date
    });
    
    setForm({ ...form, title: "", amount: "", note: "" });
  };

  return (
    <div className="page-card">
      <h2>Quick Add</h2>
      <form className="simple-form" onSubmit={submit}>
        <input name="title" placeholder="Title" value={form.title} onChange={handleChange} />
        <input name="amount" type="number" step="0.01" placeholder="Amount" value={form.amount} onChange={handleChange} />
        <select name="type" value={form.type} onChange={handleChange}>
          <option value="expense">Expense</option>
          <option value="income">Income</option>
        </select>
        <select name="category" value={form.category} onChange={handleChange}>
          <option>Food</option><option>Transport</option><option>Utilities</option><option>Shopping</option>
          <option>Health</option><option>Salary</option><option>Side Hustle</option><option>Other</option>
        </select>
        <input type="date" name="date" value={form.date} onChange={handleChange} />
        <textarea name="note" rows="3" placeholder="Note (optional)" value={form.note} onChange={handleChange}/>
        <button className="btn primary">Add</button>
      </form>
    </div>
  );
};

export default AddTransaction;
